<app-topbar></app-topbar>
<div class="container mr-top-56">
   <!-- <h1 class="mainhdng mr-bttm-30">Products & Subscriptions</h1>-->
    <a routerLink = "/dashboard" class="gobck"><img src="assets/images/gobck.png"> Go Back</a>
    <!-- Product Detail -->
    <div class="common prdct_hdng text-center mr-top-35 mr-bttm-68 addproductresptoparea">
        <img src="{{product_image_url}}{{productImage}}" class="bloomiconimg">
        <h3 class="mainhdng clrblck mr-36-52 blooaddmaintext">Simple and transparent pricing</h3>
        <div class="common prdct_paymnt">
            
            <div class="togglebttn">
                <span class="prdct_pay">Monthly Payment </span>
                <label class="switch">
                  <input type="checkbox" name="test" (change)="paymentTypeChange($event.target)" [checked] ="paymentType=='M'"/>
                  <span class="slider round"></span>
                </label>
				
                <span class="prdct_pay clrgry">Yearly (Get 2 Months Free)</span>
            </div>
        </div>
    </div>
    <!-- Product Detail -->
    <!-- Product Options -->
   
    <div class="common row mr-bttm-68 prduct_options_div frMbl" >
        <div class="col-md-6 col-sm-12 col-xs-12 resppadd0 mx-auto stndrdDiv" *ngFor="let package of productPackage; let i = index" id="cstm_box_{{i}}">
            
            <form [formGroup]="form" (ngSubmit)="submit($event)">
                <input type="hidden" name="package_id" value="{{package.id}}" class="package_id"/>
                <div class="common product_left">
                    <div class="greendiv greendivnew">
                        <p class="slctdplan">Recommended</p>
                    </div>
                    <div class="plannewdivselect">
                    <h6 class="pricehd_lft">{{package.package_name}}</h6>
                    <!--<p class="privcttxt text-center">Select number of licenses and stores</p>-->
                    <!-- Dropdown -->
                   
                    <!-- Dropdown -->
                    <p class="permnth text-center"><span><i class="fa fa-usd dlricn" aria-hidden="true"></i></span> {{paymentType == 'M' ? package.package_month_price : package.package_year_price}}/{{paymentType == 'M' ? 'Month' : 'Year'}}</p>
						 <div class="strdrpdwn">
                        <div class="strdrpdwninner">
                            <div class="nopd-lft smallfvty">
                                <label class="prdct_lbl">Licenses</label>
                                <select class="form-control prdtdrp licence_count" name="licence_count" [(ngModel)] = "package.selected_license" [ngModelOptions]="{standalone: true}">
                                    <option  *ngFor='let license of licenseCount ;let i = index' value="{{license}}" >{{license}}</option>
                                </select>
                                    
                            </div>
                        </div>
                    </div>
                    <!-- {{package.description_points | json}} -->
                    <!-- Product List -->
                    <div *ngIf = "freeTrial"><p class="text-center text-success">{{freeTrialDays}} Days Free Trial</p></div>
                    <div class="common prdct_list_div">
                           <!-- <a href="#" data-toggle="collapse" data-target="#prdct_list_ul_{{package.id}}" class="orderedwthn tblhdng">View Included Options <i class="fa fa-angle-down dwnarrw"></i></a>-->
                        <ul class="prdct_list mr-top-20 collapse show" id="prdct_list_ul_{{package.id}}">
                            <li *ngFor="let desc_points of package.description_points;">{{desc_points}}</li>
                        </ul>
                    </div>
                    <!-- Product List -->
                    <div class="common text-center">
                        <button type="submit" class="getstrtd" >Get Started</button>
                    </div>
				</div>

                </div>	
            </form>
        </div>
    </div>
    <!-- Product Options -->

</div>
<!-- Logout Modal -->
<div class="modal show" id="logoutModal" style="display: none;" aria-hidden="true">
    <div class="modal-dialog prchspopup">
      <div class="modal-content">
      
        <!-- Modal Header -->
        <div class="modal-header bluemdlhdr">
        </div>
        
        <!-- Modal body -->
        <div class="modal-body sucssbody">
          <div class="purchased_logo">
              <img src="assets/images/bloomview-icon.png">
          </div>
          <div class="common modalText">
              <h6 class="sucssheading">Are you sure you want to log out?</h6>
          </div>
          <div class="common text-center mr-top-30 logoutbttn">
              <button type="button" class="plcordrbtn wd-43" data-dismiss="modal" onclick="window.location.href='manage_store.html';">Accept </button>
              <button type="button" class="cancelbttn extndbtn" data-dismiss="modal" onclick="window.location.href='manage_store.html';">Cancel</button>
          </div>
        </div>
        
       
        
      </div>
    </div>
  </div>
<!-- Logout Modal -->
<script>
   
</script>